import { Theme } from '@mui/material';
import React, { ReactNode, createContext, useContext, useState } from 'react';
import { HeaderProps } from '../components/layouts/Header';

export interface ActiveOnlyContextProps {
  value: boolean;
  setValue: React.Dispatch<React.SetStateAction<boolean>>;
}

const ActiveOnlyContext = createContext({} as ActiveOnlyContextProps);

export const useActiveOnlyContext = (): ActiveOnlyContextProps =>
  useContext(ActiveOnlyContext);

export const ActiveOnlyContextProvider = (props: {
  children: ReactNode;
}): React.ReactElement => {
  const [value, setValue] = useState(false);

  return (
    <ActiveOnlyContext.Provider value={{ value, setValue }}>
      {props.children}
    </ActiveOnlyContext.Provider>
  );
};

export type ShowAdditionalInfoContextProps = ActiveOnlyContextProps;

const ShowAdditionalInfoContext = createContext(
  {} as ShowAdditionalInfoContextProps
);

export const useAdditionalInfoContext = (): ShowAdditionalInfoContextProps =>
  useContext(ShowAdditionalInfoContext);

export const ShowAdditionalInfoContextProvider = (props: {
  children: ReactNode;
}): React.ReactElement => {
  const [value, setValue] = useState(false);

  return (
    <ShowAdditionalInfoContext.Provider value={{ value, setValue }}>
      {props.children}
    </ShowAdditionalInfoContext.Provider>
  );
};

export interface ApplicationContextProps {
  urlBasePath: string;
  jsonBasePath: string;
  layoutBasePath: string;
  faviconPath: string;
  theOtherSiteJsonBasePath: string;
  theme: Theme;
  headerProps: HeaderProps;
  topPage: ReactNode;
  aboutPage: ReactNode;
}

const ApplicationContext = createContext({} as ApplicationContextProps);

export const useApplicationContext = (): ApplicationContextProps =>
  useContext(ApplicationContext);

export const ApplicationContextProvider = (
  props: {
    children: ReactNode;
  } & ApplicationContextProps
): React.ReactElement => (
  <ApplicationContext.Provider value={{ ...props }}>
    {props.children}
  </ApplicationContext.Provider>
);
